module.exports = __webpack_public_path__ + "img/message.a6636d0d.png";